// extracted by mini-css-extract-plugin
export default {"entry":"history_entry_row___entry___dc70f955","badge":"history_entry_row___badge___e863bdea"};